export default __webpack_public_path__ + "static/media/german.a957ee20.svg";